import React from 'react';
import { Input, Label } from 'reactstrap';
import { Form, Button, Checkbox } from 'semantic-ui-react';
import { DateTimePicker } from 'react-widgets';
import moment from 'moment';
import momentLocalizer from 'react-widgets-moment';
import { ToastContainer, toast } from 'react-toastify';
import 'react-widgets/dist/css/react-widgets.css';
import 'react-datepicker/dist/react-datepicker.css';


momentLocalizer(moment);
// TODO: move select to separate component
// props: filtersSelectedValues []
//        filtersAvailableValuesList {[],[],[]}
//         onFilterChange (fn)

export default class FilterForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          endDateErr: false,
          startDateErr: false
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.checkDate = this.checkDate.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const { graduated } = this.props.filtersSelectedValues;
        if (graduated !== nextProps.filtersSelectedValues.graduated) {
            if (nextProps.filtersSelectedValues.graduated) {
                this.props.resetOrClearFilterFormDates('reset');
            } else {
                this.props.resetOrClearFilterFormDates('clear');
            }
        }
    }

    checkDate(){
      if(this.props.filtersSelectedValues.startDate && !this.props.filtersSelectedValues.endDate){
        toast('Morate unijeti i datum kraja!');
        this.setState({endDateErr: true})
      }
      else if(!this.props.filtersSelectedValues.startDate && this.props.filtersSelectedValues.endDate){
        toast('Morate unijeti i datum početka!');
        this.setState({startDateErr: true})
      }
      else {
        this.props.changeWizardStep('next');
          this.setState({startDateErr: false, endDateErr: false})
      }
    }

    handleInputChange(event, { name, value }) {
        this.props.onFilterChange(name, value);
    }

    handleChange(event) {
        // checkboxes need to have the default event function executed or else it wont visually update

        // if (event.target.type !== 'checkbox') event.preventDefault();

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.props.onFilterChange(name, value);

        // TODO: if graduated is selected, set dates
    }
    handleDateChange(name, date) {
        if (name === 'endDate') {
            if (this.props.filtersSelectedValues.startDate && date < this.props.filtersSelectedValues.startDate) {
                this.props.onFilterChange(name, null);
                toast('Datum kraja mora biti poslije datuma početka!');
            } else this.props.onFilterChange(name, date);
        }

        if (name === 'startDate') {
            if (this.props.filtersSelectedValues.endDate && date > this.props.filtersSelectedValues.endDate) {
                this.props.onFilterChange(name, null);
                toast('Datum početka mora biti prije datuma kraja!');
            } else this.props.onFilterChange(name, date);
        }
    }
    render() {
        const { studyCycles } = this.props.filtersAvailableValuesList;
        const {
            graduated,
            locked,
            studyCycle,
            startDate,
            endDate,
            firstName,
            lastName,
            documentNumber,
        } = this.props.filtersSelectedValues;
        return (
            <div>
                <Form onSubmit={(e) => { e.preventDefault(); }}>
                    <Form.Group widths="equal">
                        <Form.Field required error={this.props.studyCycleErr}>
                            <label>Ciklus studija</label>
                            <Form.Select
                                placeholder="Odaberite ciklus studija"
                                value={studyCycle}
                                onChange={this.handleInputChange}
                                name="studyCycle"
                                options={studyCycles}
                                search
                                fluid
                            />
                        </Form.Field>
                        {!this.props.reports && <Form.Field>
                            <Label for="documentNumber">Pretraga po broju diplome</Label>
                            <Input
                                type="text"
                                name="documentNumber"
                                id="documentNumber"
                                value={documentNumber}
                                onChange={this.handleChange}
                                placeholder="Unesite broj diplome"
                            />
                        </Form.Field>}
                    </Form.Group>


                    {!this.props.reports &&<Form.Group widths="equal">
                        <Form.Field>
                            <label>Pretraga po imenu</label>
                            <input
                                type="text"
                                name="firstName"
                                id="firstName"
                                value={firstName}
                                onChange={this.handleChange}
                                placeholder="Unesite ime"
                            />
                        </Form.Field>

                        <Form.Field>
                            <label>Pretraga po prezimenu</label>
                            <Input
                                type="text"
                                name="lastName"
                                id="lastName"
                                value={lastName}
                                onChange={this.handleChange}
                                placeholder="Unesite prezime"
                            />
                        </Form.Field>

                    </Form.Group>}

                    <Form.Group widths="equal">
                        <Form.Field error={this.state.startDateErr}>
                            <label >Datum početka</label>
                            <DateTimePicker
                                format="D .M. YYYY."
                                defaultValue={null}
                                time={false}
                                onChange={this.handleDateChange.bind(null, 'startDate')}
                                value={startDate}
                            />
                        </Form.Field>
                        <Form.Field error={this.state.endDateErr}>
                            <label>Datum kraja</label>
                            <DateTimePicker
                                format="D. M. YYYY."
                                defaultValue={null}
                                time={false}
                                onChange={this.handleDateChange.bind(null, 'endDate')}
                                value={endDate}
                            />
                        </Form.Field>
                    </Form.Group>
                    <br /><br />
                    <Checkbox
                        type="checkbox"
                        name="graduated"
                        id="graduated"
                        onChange={this.handleChange}
                        checked={graduated}
                        label="Diplomirani studenti"
                    />
                    <br /><br />

                    <Checkbox
                        type="checkbox"
                        name="locked"
                        id="locked"
                        onChange={this.handleChange}
                        checked={locked}
                        label="Zaključani studenti"
                    />

                    <br /><br />

                    <Button color="blue" floated="right" onClick={this.checkDate}>Filtriraj</Button>

                    <Button color="blue" basic="true" floated="left" onClick={this.props.clearAllFilters}>Očisti filtere</Button>
                    <br /><br />

                </Form>
                <ToastContainer hideProgressBar />

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/DegreeDocumentPrint/FilterFormSS.js